import { createFileRoute } from "@tanstack/react-router";
import { getPosts } from "@/lib/blog";
import { BlogIndex } from "@/components/BlogIndex";

export const Route = createFileRoute("/es/blog/")({
  loader: () => ({ posts: getPosts("es") }),
  head: () => ({
    meta: [
      { title: "Blog — AdKavi" },
      {
        name: "description",
        content:
          "Perspectivas sobre publicidad con IA, optimización de campañas y marketing digital del equipo de AdKavi.",
      },
      { property: "og:title", content: "Blog — AdKavi" },
      {
        property: "og:description",
        content: "Perspectivas sobre publicidad con IA y marketing digital del equipo de AdKavi.",
      },
      { property: "og:type", content: "website" },
      { property: "og:locale", content: "es_ES" },
      { property: "og:url", content: "https://adkavi.ai/es/blog" },
    ],
    links: [
      { rel: "canonical", href: "https://adkavi.ai/es/blog" },
      { rel: "alternate", hreflang: "es", href: "https://adkavi.ai/es/blog" },
      { rel: "alternate", hreflang: "en", href: "https://adkavi.ai/blog" },
      { rel: "alternate", hreflang: "x-default", href: "https://adkavi.ai/blog" },
    ],
  }),
  component: EsBlogIndex,
});

function EsBlogIndex() {
  const { posts } = Route.useLoaderData();
  return <BlogIndex posts={posts} lang="es" />;
}
